import { useRequest } from "ahooks";
import { Suspense, type FC } from "react";
import { Outlet } from "react-router-dom";
import { LayoutLoading } from "@/comps/LayoutLoading";
import { FailResult } from "@/comps/FailResult";

export const RouterLayout: FC<{
  onInitial: () => Promise<void>;
}> = ({ onInitial }) => {
  const { error, loading } = useRequest(onInitial);

  if (loading) {
    return <LayoutLoading />;
  }

  if (error) {
    return (
      <FailResult
        onReload={() => {
          window.location.reload();
        }}
      />
    );
  }

  return (
    <Suspense fallback={<LayoutLoading />}>
      <Outlet />
    </Suspense>
  );
};
